<template>
    <el-dialog  :visible.sync="examFormVisible" :close-on-click-modal="false" width="88%">
        <div v-for='(item,index) in exams' :key="index">
            <div style="font-size: 16px;font-weight: bold;" v-html="item.title">>
                
            </div>
            <div style="padding:10px 20px;">
                <div v-if="item.questionType===1 || item.questionType===2" style="">
                    <el-radio-group v-model="item.yourAnswer">
                        <div class="myradio" v-for='(answer,aindex) in item.answerList' :key="aindex"><el-radio :label="answer.optionsCode">{{answer.optionsCode}}、{{answer.optionsContent}}</el-radio></div>
                    </el-radio-group>
                </div>
                 <div v-else>
                    <el-checkbox-group v-model="checkList[index]" @change="handleCheckbox(index)">
                         <div v-for='(answer,aindex) in item.answerList' :key="aindex"><el-checkbox :label="answer.optionsCode">{{answer.optionsCode}}、{{answer.optionsContent}}</el-checkbox></div>
                    </el-checkbox-group>
                 </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer" :style="showButtonvisible">
          <el-button @click.native="examFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="handleSubmit" >提交</el-button>
        </div>
      </el-dialog>
</template>
<script>
import util from '../../common/util'
import API from '../../api/exam/api_exam';
export default {
    data(){
        return{
            loading:false,
            examFormVisible:false,
            testId:'',
            rateId:'',
            examId:'',
            parentIndex:'',
            showButtonvisible:'display:block',
            exams:[],
            checkList: []
        }
    },
    methods:{
        search:function(testId,index){
            let that = this;
            that.testId=testId;
            that.parentIndex=index;
            let params={
                testId:testId
            }
            that.loading=true;
            API.getExam(params)
                .then(
                    function (result) {
                    that.loading = false;
                    if (result && result.code == 200) {
                        if(result.data )
                        {
                            that.exams=result.data;
                            let key=0;
                            that.exams.forEach((item)=>{
                                 item.title= (key+1)+". "+item.title;
                                that.$set(that.checkList, key, [])
                                item.checkList=that.checkList[key];
                                key++;
                            })
                            console.log(that.exams);
                        }
                    }
                    },
                    function (err) {
                    that.loading = false;
                    that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000
                    });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    console.log(error);
                    that.$message.error({
                    showClose: true,
                    message: "请求出现异常",
                    duration: 2000
                    });
                });
        },
        getDetail:function(examId){
             let that = this;
             let params={
                 examId:examId
             }
             console.log(params);
             API.getDetail(params)
                .then(
                    function (result) {
                        that.loading = false;
                        if (result && result.code == 200) {
                            if(result.data )
                            {
                                that.exams=result.data;
                                console.log(that.exams);
                                let key=0;
                                that.exams.forEach((item)=>{
                                    //正确答案放在题目后面
                                    item.title= (key+1)+". "+item.title+" <font style='color:red'>("+item.correct+")</font>";
                                    //选择的答案赋值
                                    let yourAnswer = item.yourAnswer;
                                    let temp=[];
                                    for(let i=0;i<yourAnswer.length;i++){
                                        temp.push(yourAnswer.substr(i,1));
                                    }
                                    that.$set(that.checkList, key, temp)
                                    key++;
                                })
                                console.log(that.exams);
                            }
                        }
                    },
                    function (err) {
                    that.loading = false;
                    that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000
                    });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    console.log(error);
                    that.$message.error({
                    showClose: true,
                    message: "请求出现异常",
                    duration: 2000
                    });
                });
        },
        handleSubmit:function(){
            let that = submit;
            that.submit();
        },
        //提交
        submit:function(){
            let that = this;
            that.$confirm('请确认是否还有未作题目?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params={
                   testId:that.testId,
                   rateId:that.rateId,
                   questions:that.exams
                };
                console.log(params);
                that.loading = true;
                API.submit(params)
                    .then(function (result) {
                        that.loading = false;
                        if (result && result.code == 200) {
                            that.$alert('<font style="font-size:28px;color:red">您的此次成绩为:'+result.data+"</font>", '本次成绩', {
                                confirmButtonText: '确定',
                                dangerouslyUseHTMLString:true,
                                callback: action => {
                                    that.examFormVisible=false;
                                    that.$emit('childCallback',that.parentIndex);
                                }
                                });
                        }else{
                        that.$message.error({
                            showClose: true,
                            message: "提交失败",
                            duration: 2000
                            });
                        }
                    },
                    function (err) {
                        that.loading = false;
                        that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000
                        });
                    }
                    )
                    .catch(function (error) {
                        that.loading = false;
                        console.log(error);
                        that.$message.error({
                            showClose: true,
                            message: "请求出现异常",
                            duration: 2000
                        });
                    });
            
            }).catch(() => {
                       
            });
        },
        resubmit:function(){
            let that = this;
            that.$confirm('请确认是否还有未作题目?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params={
                   id:that.examId,
                   rateId:that.rateId,
                   questions:that.exams
                };
                console.log(params);
                that.loading = true;
                API.resurebmit(params)
                    .then(function (result) {
                        that.loading = false;
                        if (result && result.code == 200) {
                            let totalScore=result.data;
                            that.$confirm('<font style="font-size:28px;color:red">此次成绩为:'+result.data+"，您确认覆盖上次的考试成绩吗？</font>", {
                                distinguishCancelAndClose: true,
                                dangerouslyUseHTMLString:true,
                                confirmButtonText: '确认覆盖',
                                cancelButtonText: '放弃修改'
                                })
                                .then(() => {
                                    //真正提交数据
                                    API.resurebmitsure(params)
                                        .then(
                                            function (result) {
                                                that.loading = false;
                                                if (result && result.code == 200) {
                                                    that.examFormVisible=false;
                                                    that.$emit('childCallback',that.parentIndex,totalScore);
                                                }else{
                                                    that.$message.error({
                                                        showClose: true,
                                                        message: "提交失败",
                                                        duration: 2000
                                                    });
                                                }
                                            },
                                            function (err) {
                                                that.loading = false;
                                                that.$message.error({
                                                showClose: true,
                                                message: err.toString(),
                                                duration: 2000
                                                });
                                            }
                                        )
                                        .catch(function (error) {
                                            that.loading = false;
                                            console.log(error);
                                            that.$message.error({
                                                showClose: true,
                                                message: "请求出现异常",
                                                duration: 2000
                                            });
                                        });
                                })
                                .catch(action => {
                                     that.examFormVisible=false;
                                     that.$emit('childCallback',that.parentIndex);
                                });
                        }else{
                            that.$message.error({
                                showClose: true,
                                message: "提交失败",
                                duration: 2000
                            });
                        }
                    },
                    function (err) {
                        that.loading = false;
                        that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000
                        });
                    }
                    )
                    .catch(function (error) {
                        that.loading = false;
                        console.log(error);
                        that.$message.error({
                            showClose: true,
                            message: "请求出现异常",
                            duration: 2000
                        });
                    });
            
            }).catch(() => {
                       
            });
        },
        //checkbox
        handleCheckbox:function(index){
            var that = this;
            that.exams[index].yourAnswer = that.checkList[index].join('');
            console.log(that.exams[index].yourAnswer);
        }
    },
     //页面load加载
    mounted() {
    }
}
</script>
<style scoped>
.myradio{
    line-height: 20px;
}
</style>


// WEBPACK FOOTER //
// exam.vue?39280e44